/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigningCompleteResponseDto
 */
export interface SigningCompleteResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof SigningCompleteResponseDto
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof SigningCompleteResponseDto
     */
    applicationFormId: string;
    /**
     * 
     * @type {number}
     * @memberof SigningCompleteResponseDto
     */
    versionNumber: number;
    /**
     * 
     * @type {Date}
     * @memberof SigningCompleteResponseDto
     */
    signedAt?: Date;
    /**
     * Whether all required signatures have been collected
     * @type {boolean}
     * @memberof SigningCompleteResponseDto
     */
    allSignaturesComplete: boolean;
    /**
     * Number of signatures still needed
     * @type {number}
     * @memberof SigningCompleteResponseDto
     */
    remainingSignatures: number;
}

/**
 * Check if a given object implements the SigningCompleteResponseDto interface.
 */
export function instanceOfSigningCompleteResponseDto(value: object): value is SigningCompleteResponseDto {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('applicationFormId' in value) || value['applicationFormId'] === undefined) return false;
    if (!('versionNumber' in value) || value['versionNumber'] === undefined) return false;
    if (!('allSignaturesComplete' in value) || value['allSignaturesComplete'] === undefined) return false;
    if (!('remainingSignatures' in value) || value['remainingSignatures'] === undefined) return false;
    return true;
}

export function SigningCompleteResponseDtoFromJSON(json: any): SigningCompleteResponseDto {
    return SigningCompleteResponseDtoFromJSONTyped(json, false);
}

export function SigningCompleteResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigningCompleteResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'applicationFormId': json['applicationFormId'],
        'versionNumber': json['versionNumber'],
        'signedAt': json['signedAt'] == null ? undefined : (new Date(json['signedAt'])),
        'allSignaturesComplete': json['allSignaturesComplete'],
        'remainingSignatures': json['remainingSignatures'],
    };
}

export function SigningCompleteResponseDtoToJSON(json: any): SigningCompleteResponseDto {
    return SigningCompleteResponseDtoToJSONTyped(json, false);
}

export function SigningCompleteResponseDtoToJSONTyped(value?: SigningCompleteResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'applicationFormId': value['applicationFormId'],
        'versionNumber': value['versionNumber'],
        'signedAt': value['signedAt'] == null ? undefined : ((value['signedAt']).toISOString()),
        'allSignaturesComplete': value['allSignaturesComplete'],
        'remainingSignatures': value['remainingSignatures'],
    };
}

